import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Tour from "./Tour";
import "./Help.css";

const SEEN_KEY = "tourInviteSeen";

export const TOUR_STEPS = [
  {
    target: "import",
    title: "Your inputs, from Excel or by hand",
    text: "Coming from the desktop tool? Download the template, fill it like your old input file and import it here. For a few codestrings, fill the rows below instead.",
  },
  {
    target: "bom-from",
    title: "BOM from",
    text: "Where the BOM comes from: simulate the codestring in Infor On-Premise Dev, Prd or UAT, or read a real order from Agile or Oracle.",
  },
  {
    target: "compare-with",
    title: "Compare with",
    text: "What to compare it with: another environment, the Production Database, one of your previous runs or the order in Agile or Oracle. Only get the BOM skips the comparison.",
  },
  {
    target: "codestring",
    title: "Codestring and Break down",
    text: "Paste the codestring. Break down lists its code items from RDM, so you can change one option without counting positions.",
  },
  {
    target: "create",
    title: "Create test set",
    text: "Your inputs run in the background, nothing to install and no window to keep busy. Allow notifications to get a notice when it finishes.",
  },
  {
    target: "test-sets",
    title: "Your test sets",
    text: "Every run is saved here. Open one to follow each input, see what the comparison found in Result, open the BOM or the comparison in a new tab, or download all files in one .zip.",
  },
  {
    target: "help",
    title: "The full guide",
    text: "How it works has the complete guide with screenshots, and a section for people coming from the desktop tool.",
  },
];

const readSeen = () => {
  try {
    return localStorage.getItem(SEEN_KEY) === "1";
  } catch {
    return true;
  }
};

const markSeen = () => {
  try {
    localStorage.setItem(SEEN_KEY, "1");
  } catch {
    return;
  }
};

export default function HomeTour() {
  const [params, setParams] = useSearchParams();
  const [running, setRunning] = useState(false);
  const [invite, setInvite] = useState(false);

  useEffect(() => {
    if (params.get("tour") === "1") {
      const next = new URLSearchParams(params);
      next.delete("tour");
      setParams(next, { replace: true });
      markSeen();
      setTimeout(() => setRunning(true), 300);
    } else if (!readSeen()) {
      setInvite(true);
    }
  }, [params, setParams]);

  const start = () => {
    markSeen();
    setInvite(false);
    setRunning(true);
  };

  const dismiss = () => {
    markSeen();
    setInvite(false);
  };

  const close = useCallback(() => setRunning(false), []);

  return (
    <>
      {invite && (
        <div className="tour-invite card shadow" role="region" aria-label="Page tour">
          <div className="card-body p-3">
            <div className="fw-semibold mb-1">New to BOM Compare on the web?</div>
            <p className="small text-body-secondary mb-2">
              Take a 1-minute tour of this page. It shows where everything from the desktop tool is now.
            </p>
            <div className="d-flex gap-2">
              <button type="button" className="btn btn-sm btn-primary" onClick={start}>
                Take the tour
              </button>
              <button type="button" className="btn btn-sm btn-link" onClick={dismiss}>
                No thanks
              </button>
            </div>
          </div>
        </div>
      )}
      {running && <Tour steps={TOUR_STEPS} onClose={close} />}
    </>
  );
}
